import "./style.scss";
import {Box, Button, Link, Typography} from "@mui/material";
import {openPopupWidget} from "react-calendly";
import FormHelper from "../helpers/FormHelper";
import CalcHelper from "../helpers/CalcHelper";
import calculateLoan from "../helpers/CalcHelper";

function Actions({actions, quote, amount, period, rate, purposes, purpose, requestQuoteHandler, interval}) {
    const _purposeData = FormHelper.parsePurposeData(purposes[purpose]);
    const mrepay = calculateLoan(amount, period, 1, rate);
    const wrepay = calculateLoan(amount, period, 3, rate)
    const frepay = calculateLoan(amount, period, 2, rate)
    const periodURL = period * 12;

    const handleQuote = () => {
        requestQuoteHandler();
    }
    let connectionUrl = actions.connection + "?amount=" + amount + "&term=" + periodURL + "&rate="
    + rate + "&type=" + _purposeData.lp_title;
    
    if (interval == 1) {
        connectionUrl += "&repaymentfrequency=1M&repaymentamount=" + mrepay.mrepay; // 1
    } else if (interval == 2) {
        connectionUrl += "&repaymentfrequency=2W&repaymentamount=" + frepay.mrepay; // 2
    } else {
        connectionUrl += "&repaymentfrequency=1W&repaymentamount=" + wrepay.mrepay; // 3
    }
    
    connectionUrl += "&secured=" + (_purposeData.cl_secured | 0)+ "&mortgage=" + (_purposeData.cl_mortgage| 0);

    return <>
        <Box className="calc-actions-wrapper">
            {quote ? (<>
                <Typography component="p" className="calc-actions-text">Start your Application Today</Typography>
                <Box className='calc-actions-quote'>
                    {actions.connection ? (
                    <Button className="calc-button"
                            component="a"
                          href={connectionUrl}
                    >
                        Start Application
                    </Button>
                    ):('')}
                </Box>
            </>) : (<>
                <Box className='calc-actions'>
                    <Button component="a"
                            className="calc-button"
                            onClick={handleQuote}>Start Application</Button>
                </Box>
            </>)}
        </Box>
    </>
}

export default Actions;
